<template>
  <div id="wrapper">
    <div id="content-wrapper" class="page">
      <div id="reset_password_fluid" class="container-fluid">
        <b-card
          v-if="isAdmin"
          class="mt-4 mr-auto ml-auto"
          style="width:600px; min-width:600px;"
        >
          <form @submit.prevent="updateItem" class="">
            <div class="col-lg-12">
              <div class="form-group row demo">
                <div
                  class="col-sm-3 col-form-label"
                  style="max-width: 22%; padding-left: 0; padding-right: 0;"
                >
                  <b>Search</b>
                </div>
                <div class="col-sm-9" style="max-width: 78%; flex: 0 0 78%;">
                  <vue-autosuggest
                    v-model="userQuery"
                    :suggestions="employeesuggestions"
                    :input-props="{
                      id: 'autosuggest__input',
                      placeholder: 'User?',
                    }"
                    @selected="onSelected"
                    @input="onInputChange"
                    :get-suggestion-value="getSuggestionValue"
                  >
                    <template slot-scope="{ suggestion }">
                      <div
                        class="col-sm-3 col-form-label"
                        style="width: 22%; max-width: 22%; padding-left: 0;"
                      >
                        {{ suggestion.item.manhanvien }}
                      </div>
                      <div
                        class="col-sm-3 col-form-label"
                        style="width: 33%; max-width: 33%; padding-left: 0;"
                      >
                        {{ suggestion.item.hovaten }}
                      </div>
                      <div
                        class="col-sm-3 col-form-label"
                        style="width: 45%; max-width: 45%; padding-left: 0;"
                      >
                        {{ suggestion.item.email }}
                      </div>
                    </template>
                  </vue-autosuggest>
                </div>
              </div>
              <div class="form-group row">
                <div
                  class="col-sm-3 col-form-label"
                  style="max-width: 22%; padding-left: 0; padding-right: 0;"
                >
                  <b>Email</b>
                </div>
                <div class="col-sm-9" style="max-width: 78%; flex: 0 0 78%;">
                  <input
                    type="text"
                    class="form-control"
                    name="email"
                    v-model="email"
                    autocomplete="off"
                    required
                    readonly
                  />
                </div>
              </div>
              <div class="form-group row">
                <div
                  class="col-sm-3 col-form-label"
                  style="max-width: 22%; padding-left: 0; padding-right: 0;"
                >
                  <b>Full name</b>
                </div>
                <div class="col-sm-9" style="max-width: 78%; flex: 0 0 78%;">
                  <input
                    type="text"
                    class="form-control"
                    name="hovaten"
                    v-model="hovaten"
                    autocomplete="off"
                    required
                    readonly
                  />
                </div>
              </div>
              <div class="form-group row">
                <div
                  class="col-sm-3 col-form-label"
                  style="max-width: 22%; padding-left: 0; padding-right: 0;"
                ></div>
                <div class="col-sm-9" style="max-width: 78%; flex: 0 0 78%;">
                  <b-form-checkbox
                    v-model="is_password"
                    @change="resetWithDefaultPassword"
                  >
                    Reset password with ID Card/Passport
                  </b-form-checkbox>
                </div>
              </div>
              <div class="form-group row">
                <div
                  class="col-sm-3 col-form-label"
                  style="max-width: 22%; padding-left: 0; padding-right: 0;"
                >
                  <b>Reset password</b>
                </div>
                <div class="col-sm-9" style="max-width: 78%; flex: 0 0 78%;">
                  <input
                    type="password"
                    class="form-control"
                    name="password"
                    :disabled="reset_default_password"
                    v-model="re_password"
                  />
                </div>
              </div>
              <div class="mt-4 float-right" style="max-width: 20%;">
                <b-button variant="info" type="submit" v-show="isAdmin"
                  ><i class="fas fa-save mr-2"></i>Submit</b-button
                >
              </div>
            </div>
          </form>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { VueAutosuggest } from "vue-autosuggest";
export default {
  name: "ResetPassword",
  components: {
    VueAutosuggest,
  },
  data() {
    return {
      email: null,
      hovaten: null,
      re_password: null,

      //user suggestion
      userQuery: "",
      employeeselected: null,
      employeesuggestions: [
        {
          data: [],
        },
      ],

      reset_default_password: true,
      is_password: true,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.hasPermission("system_read");
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => vm.initData());
  },
  methods: {
    initData() {
      if (!this.isAdmin) {
        this.$toast.error(
          "You do not have permission to reset User password!!!!",
          "Error",
          {
            timeout: 3000,
          }
        );
        this.$router.push(`/homepage`);
      }
    },
    updateItem() {
      if (!this.employeeselected)
        this.$toast.error("No employee has been selected yet!!!", "Error", {
          timeout: 3000,
        });
      if (
        !this.is_password &&
        (this.re_password == null || this.re_password == "")
      ) {
        this.$toast.error("Password has not been entered!!!", "Error", {
          timeout: 3000,
        });
        return;
      }
      axios
        .put("/api/employeesystem/resetpassword", {
          UId: this.employeeselected.id,
          password: this.re_password,
        })
        .then((res) => {
          this.$toast.success("Reset password sucessfully!!!", "Sucess", {
            timeout: 2000,
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          this.old_password = null;
          this.new_password = null;
          this.re_password = null;
        });
    },
    resetWithDefaultPassword() /*Default Password = ID Card/Passport Or Employee code*/ {
      if (this.is_password) {
        this.reset_default_password = false;
      } else {
        this.reset_default_password = true;
      }
    },
    onInputChange(text) {
      this.employeeselected = null;
      if (text == "") {
        this.employeesuggestions = [
          {
            data: [],
          },
        ];
      } else {
        axios
          .get(`/api/employeesystem?q=${text}`)
          .then((res) => {
            var checkAdmin = res.data.items.findIndex((x) => x.id == 2); // check Admin account
            var arr = res.data.items;
            // if (checkAdmin != -1) arr.splice(checkAdmin, 1);
            this.employeesuggestions = [{ data: arr }];
          })
          .catch((err) => {});
      }
    },
    onSelected(user_selected) {
      this.employeeselected = user_selected.item;
      this.email = user_selected.item.email;
      this.hovaten = user_selected.item.hovaten;
      this.re_password = null;
    },
    resetAutoSuggest() {
      this.employeeselected = null;
      this.email = null;
      this.hovaten = null;
      this.re_password = null;
      this.employeesuggestions = [
        {
          data: [],
        },
      ];
      this.userQuery = "";
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.hovaten + " - " + suggestion.item.email;
    },
  },
};
</script>
<style>
#reset_password_fluid .autosuggest__results-container {
  position: fixed;
  z-index: 100;
  width: 550px;
  background: #ededed;
}

#reset_password_fluid #autosuggest {
  width: 100%;
  display: block;
}
</style>
